var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            "span-method": _vm.spanMethod,
            "header-align": "center",
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("nav.plant"),
              prop: "plantName",
              width: "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.report.batchNo"),
              prop: "batchNo",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.calibration.user"),
              prop: "userName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.calibration.project"),
              prop: "project",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.calibration.spScore"),
              prop: "spScore",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.calibration.cqsScore"),
              prop: "cqsScore",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.calibration.singleScore"),
              prop: "singleScore",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: _vm.$t("sensory.calibration.calibtrateScore"),
              prop: "calibtrateScore",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }